module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_library.js
// module id = 181
// module chunks = 18 21